Ext.define('SA.data.DataFoldersAttributesRequestHandler', {
    constructor(location) {
        this.location = location;
    },

    request(folder) {
        var me = this;

        return getChildren(folder)
            .then(children => {
                var queries,
                    ids = Ext.Array.clean((children || []).map(child => child.attribute)),
                    isUserDataset = () => SA.data.UserAttributes.isUserAttribute(ids[0]);

                if (ids.length === 0) {
                    return [];
                }

                if (isUserDataset()) {
                    return SA.data.UserAttributes.getAttributes(ids);
                }

                queries = SA.Array.divide(ids, SA.data.AttributesCache.getBatchSize()).map(batchIds => updateCache(SA.data.Query.from({
                    fields: [...SA.data.AttributesCache.getFields(), 'grouped_order'],
                    limit: batchIds.length,
                    type: 'attributes',
                    where: ['in', 'attribute', batchIds]
                })));

                return Promise.all(queries.map(query => new Promise(resolve => {
                    query.addSuccess(({results}) => {
                        resolve(results);
                    });
                    query.run();
                }))).then(results => results.flat().sort((a, b) => a.grouped_order - b.grouped_order));
            });

        function getChildren(id) {
            return new Promise(resolve => {
                var cache = me.folderCache || (me.folderCache = {}),
                    children = cache[id],
                    request = () => SA.data.Tree.getChildFolders(id, me.location);

                if (children) {
                    resolve(children);
                    return;
                }

                resolve(request().then(folders => {
                    cache[id] = folders;
                    return folders;
                }));
            });
        }

        function updateCache(query) {
            var hash = query.getHash(),
                cache;

            cache = me.queryCache = me.queryCache || {};

            if (cache[hash]) {
                query = cache[hash];
            }

            cache[hash] = query;

            return query;
        }
    }
});